import { render } from "./Modal.vue?vue&type=template&id=6c6666d0&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=6c6666d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/slowko_dnia/slowko_dnia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6666d0"]])

export default __exports__